import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    csvUrl: Yup.string()
      .required("common:validator.required")
      .max(200, { code: "common:validator.maxChars", params: { max: 200 } }),
  });
};
